import { ActionTree } from 'vuex';
import { AttendeeFixedCostState } from './types';
import { RootState } from '../../types';
import { Logger } from 'fsts';
import moduleUtils from '../moduleUtils';
import { defaultBackendAttendeeFixedCost } from '@/shared/backend/attendeeFixedCost';
import attendeeFixedCost, {
  AttendeeFixedCost,
} from '@/shared/model/attendeeFixedCost';

const logger = new Logger('actions.attendeefixedCosts');
export const actions: ActionTree<AttendeeFixedCostState, RootState> = {
  getAttendeeFixedCosts(
    { commit },
    payload: { attendeeId: string; discountDate?: string }
  ) {
    return defaultBackendAttendeeFixedCost
      .getAttendeeFixedCosts(payload.attendeeId, payload.discountDate)
      .then((res) => {
        const list = res.data.map(attendeeFixedCost.parse);
        commit('setAttendeeFixedCosts', list);
        return list;
      })
      .catch((e: any) => {
        moduleUtils.error('error', commit, e, logger);
        throw e;
      });
  },
  getAttendeeFixedCostsByApplicationUserId(
    { commit },
    payload: {
      applicationUserId: string;
      discountDate?: string;
      noStore?: boolean;
    }
  ) {
    return defaultBackendAttendeeFixedCost
      .getAttendeeFixedCostsByApplicationUserId(
        payload.applicationUserId,
        payload.discountDate
      )
      .then((res) => {
        const list = res.data.map(attendeeFixedCost.parse);
        if (payload.noStore) return list;

        commit('setAttendeeFixedCosts', list);
        return list;
      })
      .catch((e: any) => {
        moduleUtils.error('error', commit, e, logger);
        throw e;
      });
  },
  postMultipleAttendeeFixedCosts(
    { commit },
    attendeeFixedCosts: AttendeeFixedCost[]
  ) {
    return defaultBackendAttendeeFixedCost
      .postMultipleAttendeeFixedCosts(attendeeFixedCosts)
      .catch((e: any) => {
        moduleUtils.error('error', commit, e, logger);
        throw e;
      });
  },
};
